module.exports = __webpack_public_path__ + "static/img/gywm_banner.3db8e59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gywm_banner.jpg
// module id = PfVV
// module chunks = 21